export const ACCESS_PLAGIARISM_CTA = 'accessPlagiarismCTA'
export const CARD_COLUMN = 'cardColumn'
export const CHANGE_SUGGESTION_DROPDOWN = 'changeSuggestionDropdown'
export const CHECK_MY_PAPER = 'checkMyPaper'
export const CLOSE_COPIED_MESSAGE = 'closeCopiedMessage'
export const CLOSE_COPIED_MESSAGE_X = 'closeCopiedMessageX'
export const COPY_BUTTON = 'copyButton'
export const DOWNLOAD_BUTTON = 'downloadButton'
export const DELETE_PAPER_BUTTON = 'deletePaperButton'
export const MY_FIRST_PAPER_LINK = 'myFirstPaperLink'
export const DISMISS_SUGGESTION = 'dismissSuggestion'
export const EDIT_MY_TEXT_BUTTON = 'editMyTextButton'
export const EXPERT_CHECK_NOTIFICATION_DOT = 'expertCheckNotificationDot'
export const FIX_IT_BUTTON = 'fixItButton'
export const GRAMMAR_TOGGLE = 'grammarToggle'
export const HELP_BUTTON = 'helpButton'
export const IGNORE_BUTTON = 'ignoreButton'
export const MORE_OPTIONS_BUTTON = 'moreOptionsButton'
export const EXPORT_BUTTON = 'exportButton'
export const MY_PAPERS_BUTTON = 'myPapersButton'
export const PLAGIARISM_TOGGLE = 'plagiarismToggle'
export const EXPERT_CHECK_TOGGLE = 'expertCheckToggle'
export const RECHECK_BUTTON = 'recheckButton'
export const RECHECK_GRAMMAR = 'recheckGrammar'
export const RECHECK_PLAGIARISM = 'recheckPlagiarism'
export const SAVE_BUTTON = 'saveButton'
export const SEE_SOURCES = 'seeSources'
export const VISIT_SOURCE_BUTTON = 'visitSourceButton'
export const RETURN_TO_PAPER_PLAGIARISM = 'returnToPaperPlagiarism'
export const RETURN_TO_PAPER_GRAMMAR = 'returnToPaperGrammar'
export const NOT_ENOUGH_TEXT = 'NotEnoughText'
export const FILTER_TOGGLE_COUNT = 'filterToggleCount'
export const FILTER_TOGGLE_SCORE = 'filterToggleScore'
export const NAV_HAMBURGER = 'navHamburger'
export const CREATE_ACCOUNT_DROPDOWN = 'createAccountDropdown'
export const SIGN_IN_DROPDOWN = 'signInDropdown'
export const LOGOUT_DROPDOWN = 'logoutDropdown'
export const LOGOUT_NAV = 'logoutNav'
export const BRANDED_BAR_UPGRADE = 'brandedBarUpgrade'
export const BRANDED_BAR = 'brandedBar'
export const BRANDED_BAR_HEADING = 'brandedBarHeading'
export const BRANDED_BAR_SUBHEADING = 'brandedBarSubHeading'
export const BRANDED_BAR_SUBHEADING2 = 'brandedBarSubHeading2'
export const PLAGIARISM_CHECK_NOTIFICATION_DOT = 'plagiarismCheckNotificationDot'
export const PAPERS_LOADING_UNRESOLVED = 'papersLoadingUnresolved'
export const MODAL_CLOSE_DEFAULT = 'modalCloseDefault'
export const DISMISS_UPSELL_TEXT = 'dismissUpsellText'
export const START_TRIAL_UPSELL_TEXT = 'startTrialUpsellText'
export const SPELLCHECK_SUGGESTION_COUNT = 'spellcheckSuggestionCount'
export const LANGUAGE_SUGGESTION_COUNT = 'languageSuggestionCount'
export const UPSELL_CUSTOM_SUMMARY = 'upsellSummaryText'
export const UPSELL_RECEIVE_COMMENT = 'upsellReceiveComment'
export const UPSELL_SUBMIT_ONE_PAPER = 'upsellSubmitOnePaper'
export const TERMS_LINK = 'termsLink'
export const PLAGIARISM_CHECK_RUNNING_SPINNER = 'plagiarismCheckRunningSpinner'
export const PLAGIARISM_CHECK_SUCCESS_CHECKMARK = 'plagiarismCheckSuccessCheckmark'
export const PLAGRIARISM_CHECK_FAILURE_X = 'plagiarismCheckFailureX'
export const CARD_ITEMS = 'cardItems'
export const NOOP_PLAG_CARD = 'noopPlagCard'
export const PHONE_CARDS_CONTAINER = 'phoneCardsContainer'
export const EDITOR_TEST_ID = 'editor'
export const TOAST_TEST_ID = 'toast'
export const CURRENT_FILTER_TEST_ID = 'currentFilter'
export const MORE_OPTIONS_PHONE_BUTTON = 'moreOptionsPhoneButton'
export const HEADER_LEFT_NAV = 'headerLeftNav'
export const HEADER_LEFT_NAV_MENU = 'headerLeftNavMenu'
export const HEADER_LEFT_NAV_DROPDOWN = 'headerLeftNavDropdown'
export const OWL_RULE_LINK = 'owlLink'
export const LEAVE_MODAL_LEAVE = 'leaveModalLeave'
export const LEAVE_MODAL_STAY = 'leaveModalStay'
export const LEAVE_MODAL_STAY_CLOSE = 'leaveModalStayClose'
export const PLAGIARISM_CHECK_MODAL_HEADING = 'plagiarismCheckModalHeading'
export const PLAGIARISM_CHECK_MODAL_SUB_HEADING = 'plagiarismCheckModalSubHeading'
export const SIGNUP_LINK = 'test-signup'
export const SIGNIN_LINK = 'test-signin'
export const TOKEN_LOADING_ICON = 'tokenLoadingIcon'
export const UNDO_REPLACEMENT_BUTTON = 'undoReplacementButton'
export const UNDO_CLOSE_BUTTON = 'undoCloseButton'
export const PLANS_PAGE = 'plansPage'

// layout ids
export const SMALL_EDITOR_TEST_ID = 'smallEditor'
export const MEDIUM_EDITOR_TEST_ID = 'mediumEditor'
export const MEDIUM_TABS_TEST_ID = 'mediumTabs'
export const FULL_EDITOR_TEST_ID = 'fullEditor'

export const MEDIUM_WORKSPACE_ID = 'mediumWorkspace'
export const SMALL_WORKSPACE_ID = 'smallWorkspace'
export const FULL_WORKSPACE_ID = 'fullWorkspace'

export const FULL_LEFT_PANEL_ID = 'fullLeftPanel'
export const MEDIUM_MENU_ID = 'mediumMenu'
export const SMALL_MENU_ID = 'smallMenu'

export const WORKSPACE_MAIN_ID = 'workspaceMain'

// More Actions
export const MORE_ACTIONS_UPGRADE = 'moreActionsUpgrade'
export const LOCALE_SWITCHER = 'localeSwitcher'
export const LOCALE_EN_GB = 'localeGB'
export const LOCALE_EN_US = 'localeUS'
export const LOCALE_EN_CA = 'localeCA'
export const LOCALE_EN_AUS = 'localeAUS'

export const PAYMENT_MODAL_TEST_ID = 'paymentModal'
export const PAPER_SCORECARD_MODAL_TEST_ID = 'paperScorecardModal'

// Expert Check ids

export const EC_PAGE_ID = 'eCPage'
export const EC_UPGRADE_PAGE_ID = 'eCUpgradePage'
export const EC_FORM_PAGE_ID = 'eCFormPage'
export const EC_SUCCESS_PAGE_ID = 'eCSuccessPage'
export const EC_IN_PROGRESS_PAGE_ID = 'eCInProgressPage'
export const EC_COMPLETE_PAGE_ID = 'eCCompletePage'
export const EC_DEMO_PAGE_ID = 'eCDemoPage'
export const EC_ERROR_PAGE_ID = 'eCErrorPage'

export const EC_UPGRADE_VIDEO_ID = 'ecUpgradeVideo'
export const EC_FORM_EDIT_CTA_ID = 'ecFormEditCTA'
export const EC_FORM_EXCERPT_ID = 'eCFormExcerpt'
export const EC_FORM_PAPER_ERROR_FOCUS_ID = 'ecFormPaperErrorFocus'
export const EC_FORM_EMAIL_LABEL_ID = 'ecFormEmailLabel'
export const EC_FORM_EMAIL_INPUT_ID = 'eCFormEmailInput'
export const EC_FORM_EMAIL_ERROR_FOCUS_ID = 'eCFormEmailErrorFocus'
export const EC_FORM_UPLOAD_CTA_ID = 'eCFormUploadCTA'
export const EC_FORM_INFO_TEXT_AREA_ID = 'ecFormInfoTextArea'
export const EC_FORM_SUBMIT_BUTTON_ID = 'ecFormSubmitButton'
export const EC_FORM_ADDITIONAL_INFO_ID = 'ecFormAdditionalInfo'
export const EC_START_TRIAL_BUTTON_ID = 'ecStartTrialButton'
export const EC_SUBMIT_FREE_SAMPLE_BUTTON_ID = 'ecSubmitFreeSampleButton'
export const EC_FAQ_LINK = 'ecFAQLink'
export const EC_HEADING_ID = 'ecHeading'
export const EC_SUB_TEXT_ID = 'ecSubText'

const IN_APP = 'InApp'
export const EC_SUCCESS_PAGE_ID_IN_APP = `${EC_SUCCESS_PAGE_ID}${IN_APP}`
export const EC_IN_PROGRESS_PAGE_ID_IN_APP = `${EC_IN_PROGRESS_PAGE_ID}${IN_APP}`
export const EC_COMPLETE_PAGE_ID_IN_APP = `${EC_COMPLETE_PAGE_ID}${IN_APP}`
export const EC_FAQ_LINK_ID_IN_APP = `${EC_FAQ_LINK}${IN_APP}`
export const EC_FEEDBACK_TIME = `ecFeedbackTime`
export const EC_RESUBMIT_BUTTON_ID = `ecResubmitButton`
export const EC_CRITERION_FEEDBACK = 'ecCriterionFeedback'
export const EC_FEEDBACK_PLEASE_NOTE_ID = `ecFeedbackPleaseNote`
export const EC_FEEDBACK_UNLOCK_MODULE = 'ecFeedbackUnlockModule'
export const EC_FEEDBACK_UNLOCK_CTA = 'ecFeedbackUnlockCta'

export const GRAMMAR_CARD_CTA_LIGHT = 'grammarCardCtaLight'

// Scorecare ids
export const SCORECARD_CONTAINER_ID = 'scorecardContainer'
export const SCORE_DETAIL_LINK_ID = 'scoreDetailLink'
export const PROGRESS_BAR_ID = 'progressBarContainer'

// Demo Workspace ids
export const SUBMIT_CARD_CTA_LIGHT = 'submitCardCtaLight'
export const UPLOAD_WIDGET_MODAL_CLOSE_BUTTON_ID = 'uploadWidgetModalCloseButton'
export const DEMO_GRAMMAR_SUGGESTION_TEXT_ID = 'demoGrammarSuggestionText'
export const DEMO_FTS_BANNER_ID = 'demoFtsBanner'
export const DEMO_FTS_BANNER_CTA_BUTTON_ID = 'demoFtsBannerCtaButton'
export const DEMO_FTS_BANNER_PLAG_COPY_ID = 'demoFtsBannerPlagCopy'
export const DEMO_FTS_BANNER_GRAMMAR_COPY_ID = 'demoFtsBannerGrammarCopy'
export const DEMO_EDITOR_LABEL = 'demoEditorLabel'
export const DEMO_UPLOAD_WIDGET_MODAL_OPEN_BUTTON_ID = 'demoUploadWidgetModalOpenButton'
export const DEMO_BANNER_HEADER_ID = 'demoBannerHeader'
export const DEMO_BANNER_HEADER_CTA_BUTTON_ID = 'demoBannerHeaderCtaButton'
export const DEMO_EC_PAGE_CTA_BUTTON_ID = 'demoEcPageCtaButton'



// WEBPACK FOOTER //
// ./src/utils/dataTestIds/index.ts